// extracted by mini-css-extract-plugin
module.exports = {"pt-lab-product-table":"pt-lab-product-table-a601055a40f03cc775936571df2b5ec0"};